import { render, staticRenderFns } from "./WorkflowSaldenAntrag.vue?vue&type=template&id=8bc07ffc&scoped=true"
import script from "./WorkflowSaldenAntrag.vue?vue&type=script&lang=ts"
export * from "./WorkflowSaldenAntrag.vue?vue&type=script&lang=ts"
import style0 from "./WorkflowSaldenAntrag.vue?vue&type=style&index=0&id=8bc07ffc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bc07ffc",
  null
  
)

export default component.exports